<script>
import PersonalMessage from '@components/personal-message/personal-message.vue'
import Cards from '@components/card/card-component.vue'
import { cardData } from '@components/card/card-data'
import { authComputed, authMethods } from '@state/helpers'
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
export default {
  page: {
    title: 'Index',
    meta: [{ name: 'description', content: 'The health help page.' }],
  },
  components: {
    PersonalMessage,
    Cards,
  },
  mixins: [layout, NavigateMixin],
  props: {},
  data() {
    return {
      messages: [
        {
          id: '1',
          title: 'How are you feeling today?',
          felling: [
            {
              status: 'Great!',
              icon: require('@assets/images/safehaven/Emoticon-Happy.png'),
              Isicon: true,
            },
            {
              status: 'Just OK',
              icon: require('@assets/images/safehaven/Emoticon-JustOK.png'),
              Isicon: true,
            },
            {
              status: 'Bad',
              icon: require('@assets/images/safehaven/Emoticon-Bad.png'),
              Isicon: true,
            },
          ],
        },
      ],
      dialog: false,
      cards: cardData,
      hide: true,
    }
  },
  computed: {
    ...authComputed,
  },
  async mounted() {
    const userData = JSON.parse(localStorage.getItem('auth.currentUser'))
    if (userData.user.answer_saved) {
      this.hide = false
    }
  },
  methods: {
    ...authMethods,
  },
}
</script>

<template>
  <div :class="$style.dashboardContainer">
    <v-row no-gutters>
      <v-col>
        <PersonalMessage
          v-for="message in messages"
          :id="message.id"
          :key="message.id"
          :title="message.title"
          :felling="message.felling"
        ></PersonalMessage>
      </v-col>
    </v-row>
    <v-container v-if="hide" fluid mt-8>
      <v-row no-gutters>
        <v-col cols="12" xl="4" lg="4" md="4" sm="12" xs="12">
          <v-img
            height="300"
            contain
            :src="require('@assets/images/safehaven/Dashboard-Yoga@2x.png')"
          ></v-img>
        </v-col>
        <v-col cols="12" xl="8" lg="8" md="8" sm="12" xs="12">
          <div :class="$style.contentWrapp">
            <h1 :class="$style.title"
              >Guiding you to your next best health action.</h1
            >
            <p :class="$style.desc"
              >Ready to start improving your life? HealthBook+ gives you the
              ability to own, control and manage your family’s health care and
              wellness. Let’s start by answering some simple questions so we can
              get to know you better and personalize your experience.</p
            >
            <v-btn
              :class="$style.btnClass"
              @click="navigateToScreen('profile-questionnaire')"
              >Quick Questionnaire</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid :class="$style.mrclss" mt-8 px-8 pb-3>
      <h1 :class="$style.title">Health Dashboard </h1>
      <p class="mb-0" :class="$style.desc"
        >Nothing to see here yet! Your health dashboard gives you a complete
        health picture and uses predictive analytics to improve your future
        wellness.</p
      >
    </v-container>
    <v-container pt-0 fluid>
      <v-row no-gutters>
        <Cards
          v-for="card in cards"
          :key="card.id"
          :img="card.src"
          :desc="card.desc"
          :btn="card.title"
        ></Cards>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.dashboardContainer {
  width: 100%;
  background: #f2f9ff;
}
.title {
  margin: 0 0 15px;
  font-size: 28px;
  font-weight: 400;
}
.desc {
  margin-bottom: 20px !important;
  font-size: 16px;
  line-height: 24px;
}
.contentWrapp {
  padding: 30px 30px 0 0;
}
.btnClass {
  width: 240px;
  padding: 26px !important;
  font-size: 18px !important;
  font-weight: 600;
  color: #fff !important;
  text-transform: inherit;
  letter-spacing: inherit;
  background: #0476d9 !important;
  border: none;
  border-radius: 30px;
}
@media screen and (max-width: 1904px) {
  .contentWrapp {
    padding-left: 40px;
  }
}
@media screen and (max-width: 1366px) {
  .desc {
    width: 100%;
  }
  .contentWrapp {
    padding: 40px;
  }
}
@media screen and (max-width: 959px) {
  .contentWrapp {
    padding: 40px 20px 0;
  }
}
@media screen and (max-width: 680px) {
  .title {
    text-align: center;
  }
  .desc {
    text-align: center;
  }
  .btnClass {
    width: 100%;
  }
  .contentWrapp {
    padding: 20px 20px 0;
  }
  .dashboardContainer .mrclss {
    margin-top: 10px !important;
  }
}
</style>
